import { render } from "./CurrentTicketPackages.vue?vue&type=template&id=ac19c350"
import script from "./CurrentTicketPackages.vue?vue&type=script&lang=js"
export * from "./CurrentTicketPackages.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__